import { ReturnStatement } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { Locale } from 'src/app/moov-common/enum/locale.enum';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { UserResponsePresentationDataTypeEnum } from 'src/app/moov-common/services/responses/response.enum';
import { UserResponsePresentationData } from 'src/app/moov-common/services/responses/responses-data';
import { ResponsesAbstractService } from 'src/app/moov-common/services/responses/responses.abstract.service';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';

@Component({
  selector: 'app-user-response',
  templateUrl: './user-response.component.html',
  styleUrls: ['./user-response.component.scss']
})

export class UserResponseComponent extends BaseComponent implements OnInit {
  timerToClose = 5;
  remaingTimeToClose = 0;
  responseSent= false;
  presentSpinner = false;
  responseSucceeded = false;
  responsePresenationDetails : UserResponsePresentationData;
  localeExternal = "";
  userResponseAssetsRootFolder = 'assets/userResponse';
  userParam_tokenBody = "";
  userParam_score = 0;
  userResponsePresentationDataTypeEnum_Instance = UserResponsePresentationDataTypeEnum;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private responsesService : ResponsesAbstractService,
              private userDataService : AbstractPersonalUserDataService) { 
    super();

  }

  ngOnInit(): void {
    super.ngOnInit();
    
  }

  ngAfterViewInit(): void{
    // return;
    this.route.queryParams.subscribe(params => {
      this.userParam_tokenBody = params.tokenBody;
      this.userParam_score = params.score;
      this.localeExternal = params.locale;
      

      if (this.userParam_tokenBody == undefined || this.userParam_score == undefined){
        // console.log(`in TV onInit dbgCounterpartId is undefined`);
        this.router.navigate( [NAVIGATION_ROUTES.app.personalView]);        
      }

      if (this.localeExternal == undefined){
        this.localeExternal = 'en-US';
      }
      this.setRTL();
      this.userDataService.setLocale(this.localeExternal);

      this.presentSpinner = true;

      this.responsesService.sendUserResponse(this.userParam_tokenBody, this.userParam_score).subscribe(userReponsePresentationData => {
        this.responsePresenationDetails = userReponsePresentationData;       

        this.analytics.identify(userReponsePresentationData.userId);

        // this is a workaround to fix the issue that the identify call is not yet completed. Ugly but works.
        setTimeout(() => {
          this.analytics.userRespondedToDriverGapQuestion(userReponsePresentationData.userId, userReponsePresentationData.orgId, userReponsePresentationData.mailAddress);
        }, 200);

        this.responseSent= true;
        this.presentSpinner = false;
        
      }, error =>{
        this.analytics.UserFailedToResponsedToQuestioner();
        this.responseSent= true;
        this.presentSpinner = false;
      });
    });
  }

  getUserImagePath(): string{
    if (!this.responsePresenationDetails){
      return this.userResponseAssetsRootFolder + '/userResponse_tokenIssues.svg';
    }
    else if (this.responsePresenationDetails.engagementType == UserResponsePresentationDataTypeEnum.MyManagerTip){
      return this.userResponseAssetsRootFolder + '/userResponse_tip.svg';
    }
    else {
      return this.userResponseAssetsRootFolder + '/userResponse_manager.svg';
    }
  }

  get isRTL(): boolean {
    if (!this.user && (this.localeExternal == undefined || this.localeExternal == "")){
      let locale = this.utilsService.getBrowserLocale();

      if (locale === Locale.he_IL){
        return true;
      }
      else {
        return false;
      }
    }
    else if (!this.user && this.localeExternal != ""){
      if (this.localeExternal === Locale.he_IL){
        return true;
      }
      else {
        return false;
      }
    }
    else {
      // user is logged in
      return super.isRTL;
    }
  }

  setRTL() {
    this.isRTL ? document.body.style.direction = 'rtl' : document.body.style.direction = 'ltr';    
  }

  sleep(miliseconds:number) {
    return new Promise(resolve => setTimeout(resolve, miliseconds));
  }

  redirectToLogin(){
    this.router.navigate([NAVIGATION_ROUTES.login]);
  }

  sendTipToSelf() {
      this.presentSpinner = true;
      this.responsesService.sendTipToSelf(this.userParam_tokenBody).subscribe(result => {

        this.presentSpinner = false;
      });
  }

  redirectToChat() {
    const returnUrl = this.responsePresenationDetails.returnUrl;

    let allQueryParams_Raw = returnUrl.substring(returnUrl.indexOf('?') + 1);
          
    let queryParams = allQueryParams_Raw.split('&');
    
    let queryParamsList : JSON = JSON.parse('{}');

    for (let currQueryParam of queryParams){
      // now we have pairs, each currQueryParam looks like 'param_x=val_x'
      let currQueryParamsPairList : string[] = currQueryParam.split('=');
      let currQueryParamsPair = {[currQueryParamsPairList[0]]: currQueryParamsPairList[1]};

      queryParamsList= Object.assign(queryParamsList, currQueryParamsPair);
    }
    
    this.router.navigate([NAVIGATION_ROUTES.app.chatView], {queryParams: queryParamsList});
  }
}
